import fillWithZeros from "./fillWithZeros.helper"

export const formatCPF = value => {
  if (!value) return

  let cpf = fillWithZeros(11, value.toString())

  cpf = cpf.replace(/[^\d]/g, "")
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
}

export const formatCNPJ = value => {
  if (!value) return

  let cnpj = fillWithZeros(14, value.toString())

  cnpj = cnpj.replace(/[^\d]/g, "")
  return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
}

export const formatCEP = value => {
  if (!value) return

  let cep = value?.replace(/[^\d]/g, "")
  return cep.replace(/(\d{5})(\d{3})/, "$1-$2")
}

export const formatCellphone = value => {
  if (!value) return

  const phone = value?.replace(/[^\d]/g, "")
  return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
}

export const formatLandline = value => {
  if (!value) return

  const landline = value?.replace(/[^\d]/g, "")
  return landline.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3")
}

export const formatBirthdate = value => {
  const valueWithoutBlanks = value.replace(/ /g, "")
  const dividedValueToArray = valueWithoutBlanks.split("/")
  const revertedArray = dividedValueToArray.reverse()
  const joinedArrayToString = revertedArray.join("-")
  return joinedArrayToString
}

export const formatPriceToDisplay = price => {
  const floatPrice = parseFloat(price?.toString()?.replace(",", "."))
  if (isNaN(floatPrice)) return ""
  return `R$ ${floatPrice.toFixed(2).toString().replace(".", ",")}`
}
